"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeInput = exports.generateRandomString = exports.handleAsyncError = exports.createError = exports.calculatePagination = exports.canManageFiles = exports.canManageDevices = exports.canManageUsers = exports.hasPermission = exports.validateUUID = exports.validateEmail = exports.isExpired = exports.formatDate = exports.sanitizeFilename = exports.formatFileSize = exports.getFileExtension = void 0;
const types_1 = require("../types");
// File utilities
const getFileExtension = (filename) => {
    return filename.slice((filename.lastIndexOf('.') - 1 + 2) * 2);
};
exports.getFileExtension = getFileExtension;
const formatFileSize = (bytes) => {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
exports.formatFileSize = formatFileSize;
const sanitizeFilename = (filename) => {
    return filename.replace(/[^a-zA-Z0-9.-]/g, '_');
};
exports.sanitizeFilename = sanitizeFilename;
// Date utilities
const formatDate = (date) => {
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(date);
};
exports.formatDate = formatDate;
const isExpired = (date) => {
    return new Date() > date;
};
exports.isExpired = isExpired;
// Validation utilities
const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
exports.validateEmail = validateEmail;
const validateUUID = (uuid) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
};
exports.validateUUID = validateUUID;
// Permission utilities
const hasPermission = (userRole, requiredRole) => {
    const roleHierarchy = {
        [types_1.UserRole.SUPER_ADMIN]: 4,
        [types_1.UserRole.ADMIN]: 3,
        [types_1.UserRole.OFFICE_WORKER]: 2,
        [types_1.UserRole.UNASSIGNED]: 0
    };
    return roleHierarchy[userRole] >= roleHierarchy[requiredRole];
};
exports.hasPermission = hasPermission;
const canManageUsers = (userRole) => {
    return userRole === types_1.UserRole.SUPER_ADMIN || userRole === types_1.UserRole.ADMIN;
};
exports.canManageUsers = canManageUsers;
const canManageDevices = (userRole) => {
    return userRole === types_1.UserRole.SUPER_ADMIN || userRole === types_1.UserRole.ADMIN;
};
exports.canManageDevices = canManageDevices;
const canManageFiles = (userRole) => {
    return userRole === types_1.UserRole.SUPER_ADMIN || userRole === types_1.UserRole.ADMIN;
};
exports.canManageFiles = canManageFiles;
// Pagination utilities
const calculatePagination = (total, page, limit) => {
    const totalPages = Math.ceil(total / limit);
    const offset = (page - 1) * limit;
    return {
        page,
        limit,
        total,
        totalPages,
        offset,
        hasNext: page < totalPages,
        hasPrev: page > 1
    };
};
exports.calculatePagination = calculatePagination;
// Error handling
const createError = (message, statusCode = 400) => {
    const error = new Error(message);
    error.statusCode = statusCode;
    return error;
};
exports.createError = createError;
const handleAsyncError = (fn) => {
    return (req, res, next) => {
        Promise.resolve(fn(req, res, next)).catch(next);
    };
};
exports.handleAsyncError = handleAsyncError;
// Security utilities
const generateRandomString = (length = 32) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};
exports.generateRandomString = generateRandomString;
const sanitizeInput = (input) => {
    return input.replace(/[<>]/g, '');
};
exports.sanitizeInput = sanitizeInput;
